<div class="basic-flex-container" [ngClass]="{'disabled': options.length === 0}"
  [matTooltip]="tooltipString" matTooltipShowDelay="500">
  <mat-icon fontIcon="{{ icon }}"></mat-icon>
  <div class="options-container">
    @if (!selectedOption) {
      <span class="multi-select-placeholder">{{ placeholder }}...</span>
    }
    <mat-select class="full-width truncate"
      [disabled]="(options.length <= 1)"
      [(ngModel)]="selectedOption"
      (selectionChange)="onSelectionChange($event)">
      @for (option of options; track $index) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </div>
</div>
